// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".modal-enrollment-certificates--layout .modal-enrollment-certificates--table-actions {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  justify-content: flex-end; }\n\n.modal-enrollment-certificates--layout .modal-enrollment-certificates--actions {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  justify-content: flex-end; }\n", ""]);
// Exports
module.exports = exports;
